import { JSONSchema7 } from "json-schema";

export const ExplainAudioMetadataSchema: JSONSchema7 = {
  description: "Audio explanation.",
  type: "object",
  $schema: "http://json-schema.org/draft-07/schema#",
};
